<template>
  <div class="content">
    <h1>Dag 2</h1>
    <img src="/static/images/cc22_su.svg" alt="spiludvikling" style="width: 50%;" />
    <h2>I dag skal I:</h2>

    <p>&bull; Brainstorme, og finde ud af, hvilket slags spil I vil lave!</p>
    <p>
      &bull; Igang med at tegne karakterer, objekter og baggrunde til spillet!
    </p>
    <p>&bull; Igang med at kode spillet!</p>
    
    <br />
    <h3>I skal arbejde sammen to og to<br> <br>
      Udskriv arkene her så hver gruppe har et sæt.</h3>

    <br />
    <a class="purp" href="https://drive.google.com/file/d/1L66IxRZh1AURWbDRhd0erCoPKwDWx_N3/view?usp=sharing"
      target="_blank">Coding Class Odense spiludviklingsark</a>

    <h3>
      <br>Her på siden kan I se hvornår I skal bruge hvilke ark.
    </h3>
    <h3>
      <span class="bullet">1</span> Fælles brainstorm på tavlen over det valgte emne.<br>
      Tid: 10-30 min. <br />
    </h3>
    <img src="/static/images/cc22_brainstorm2.svg" alt="brainstorm" style="width: 50%;" />

    <p>&nbsp;</p>

    <div>
      <h3><span class="bullet">2</span> I skal vælge hvilken type jeres spil skal være. </h3>
      <p>Der er 4 forskellige spil at vælge i mellem: Platformspil, labyrintspil, skydespil og scroller.</p>
      <p>Læs mere om spiltyperne nedenfor og se eksempler på spil, som er blevet lavet i Coding Class.</p>
      <p>Klik på billedene for at prøve spillene.</p>

      <h1>Platformspil</h1>
      <p>Et spil hvor du skal hoppe fra platform til platform og undgå at falde ned. <br />
        Måske kan man samle mønter eller andre ting, for at få point. <br />
        Måske skal man undgå at blive ramt af lyn eller farlige dyr.</p>

      <strong>Eksempler på platformsspil lavet i Coding Class</strong>
      <div class="spiltype-eks-container">
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/532027531/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/platform1.png" alt="Platform 1" />
        </a>
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/542782935/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/platform2.png" alt="Platform 2" />
        </a>
      </div>

      <h1>Labyrintspil</h1>
      <p>Et spil hvor du skal styre din karakter igennem en labyrint. <br />
        Måske skal du nå igennem labyrinten på tid, samle mønter, og/eller undgå
        at blive ramt af bomber.</p>

      <strong>Eksempler på labyrintspil lavet i Coding Class</strong>
      <div class="spiltype-eks-container">
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/634138106/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/labyrint1.png" alt="Labyrint 1" />
        </a>
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/544568841/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/labyrint_ny_2.png" alt="Labyrint 2" />
        </a>
      </div>

      <h1>Skydespil</h1>
      <p>Et spil hvor man skal skyde eller kaste efter ting, objekter eller endda en
            modspiller. </p>
        
      <strong>Eksempler på skydespil lavet i Coding Class</strong>
      <div class="spiltype-eks-container">
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/573410378/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/skydespil_ny_2.png" alt="Skydespil 1" />
        </a>
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/606881578/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/skyde2.png" alt="Skydespil 2" />
        </a>
      </div>

      <h1>Scroller</h1>
      <p>I et scrollerspil bliver du hele tiden på den samme skærm, <br />
        men det ser ud som om du bevæger dig, <br />fordi andre ting i spillet, flytter sig.</p>

      <strong>Eksempler på scrollerspil lavet i Coding Class</strong>
      <div class="spiltype-eks-container">
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/638376699/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/scroller1.png" alt="Scrollerspil 1" />
        </a>
        <a class="spiltype-eks" href="https://scratch.mit.edu/projects/851777300/fullscreen/"
          target="_blank">
          <img src="/static/images/spiltype/scroller2.png" alt="Scrollerspil 2" />
        </a>
      </div>
    </div>

    <p>&nbsp;</p>
    <p>&nbsp;</p>

    <h3>
      <span class="bullet">3</span> Hver gruppe skal få minimum 3 spil-idéer. <br>
      Brug ark nr. 1. <br>
      Tid: 15-20 min.
    </h3>
    <h3>
      <span class="bullet">4</span> Vælg den bedste idé ud. <br><br>
    <img src="/static/images/cc22_idea1.svg" alt="idea" style="width: 25%;" />
<br><br>
      Den skal både være sjov, original og mulig at lave på én dag. <br>
      Tid: 5 min.<br />

    </h3>
    <h3>
      <span class="bullet">5</span> Beskriv og tegn jeres idé mere detaljeret. <br><br>
    <img src="/static/images/cc22_stm_test.svg" alt="storytelling" style="width: 75%;" />

      <br> Hvad er historien bag/missionen i jeres spil? <br>
      Brug ark nr 2 og 3 <br>
      Tid: 30-45 min<br />
    </h3>
  
  
    <h3><span class="bullet">6</span> Skriv ned hvad der er absolut nødvendigt at kode og tegne for at spillet virker.
      <br>
      ..Og skriv ned hvad der ville være super fedt også at nå, <br>
      men som I først går igang med, når det andet er færdigt. <br>
      Brug ark nr 4 <br>
      Tid: 15-20 min
    </h3>


    <h3><span class="bullet">7</span> Beslut jer for, hvem der skal kode og hvem der skal tegne. <br>
      Nu er I klar til at komme igang!
    </h3>
    <p>&nbsp;</p>
    <p>&nbsp;</p>

















    <h3>Herunder skal du vælge hvilken rolle du har:</h3>
    <ul class="iam">
      <li>
        <a @click="showKind = 'code'" :class="{ active: showKind == 'code' }">Koder</a>
      </li>
      <li>
        <a @click="showKind = 'draw'" :class="{ active: showKind == 'draw' }">Tegner</a>
      </li>
    </ul>

    <div v-if="showKind == 'draw'">
      <h3>Nu skal du igang med at tegne!</h3>

      Gå ind på
      <a href="https://www.piskelapp.com" target="_blank">piskelapp.com</a> for
      at komme igang.
      <br />
      Husk at ændre formatet til enten 48x36 eller 480x360 <br />
      <img src="/static/images/learning/dag2/piskel_resize.svg" style="width: 800px;" alt="resize" />
      <br />

      Hvis du vil tegne pixeleret skal du tegne i formatet 48x36. <br />
      Hvis du vil tegne detaljeret skal du tegne i formatet 480x360. <br />
      Se her hvad forskellen er. <br />
      <img src="/static/images/learning/dag2/piskel_size.svg" style="width: 800px;" alt="sizes" />
      <br />
      <br />

      Når du er færdig med hver tegning skal du huske at gemme dem i dit galleri
      og at eksportere dem til dit drev. <br />
      <img src="/static/images/learning/dag2/piskel_save.svg" style="width: 800px;" alt="" />
      <br />
      Husk at sætte et nul bag på, hvis du har tegnet i formatet 48x36. <br />
      Se evt. videoerne fra dag 1 igen. <br />

      <br />
      <br />
      <h1>God arbejdslyst!</h1>
      <p>&nbsp;</p>
    </div>
    <div v-if="showKind == 'code'">
      <h3>Nu skal du igang med at kode spillet!</h3>

      <p>
        Gå ind på <a href="https://www.skoletube.dk/sk-apps/codinglab/" target="_blank">CodingLab</a> 
      </p>
      <p>Et nyt projekt startes automatisk, og du er nu klar til at kode!<br/></p>

      <p style="font-weight:bold">Du skal ikke vente på, at din makker har tegnet figurer og baggrunde. <br/>
          Bare start med at bruge sprites fra CodingLab, <br/> og så skift dem ud
            med de rigtige tegninger, når de bliver færdige.</p>
    
   <div
          style="max-width: 400px; padding: 18px 18px; margin: 0 auto; font-weight:bold; color: white; border-radius: 12px; background-color: #ff00f9">
  
          <h3 style="padding:0;margin:0;">Du kan starte med en tutorial herunder, eller scrolle direkte ned til de 3 videoer der forklarer, hvordan du finder inspiration på Scratch.
   
</h3></div>
        
        
   
      
      <p>Følg den video tutorial, der passer til den type spil I har
        besluttet at lave:</p>
      <p>
        <router-link class="purp" to="/video-tutorials/scroller" style="width: 150px;">Scroller</router-link>
     
        <router-link class="purp" to="/video-tutorials/platformer" style="width: 150px;">Platformer</router-link>
     
        <router-link class="purp" to="/video-tutorials/labyrint" style="width: 150px;">Labyrint</router-link>

        <router-link class="purp" to="/video-tutorials/skyde" style="width: 150px;">Skydespil</router-link>
      </p>

      <div style="max-width: 600px; margin: 0 auto;">
      
        <h3>Se videoerne herunder for at finde ud af, <br/> hvordan du finder inspiration og hjælp på <a href="https://scratch.mit.edu" target="_blank">Scratch.</a> </h3>
  
        <EmbedYoutube id="Ndwp-Q7m0zE"  />
          <EmbedYoutube id="gYGtWkk49xk"  />
          <EmbedYoutube id="Ox1-8eDZfnc"  />
          <br/>
          
          <h3>Du kan også kigge på udvalgte 
        <router-link to="/tips-og-tricks/scratch-projekter" target="_blank" style="display:inline-block;">Scratch-projekter</router-link>
       </h3>
       <h3>..Og søge hjælp på 
       <a href="https://en.scratch-wiki.info/" target="_blank">Scratch Wiki</a> </h3>
        <br />
        <br />
        <h1>God arbejdslyst!</h1>
        <p>&nbsp;</p>
      </div>
    </div>
  </div>
</template>

<script>
import EmbedScratch from "@/components/ScratchEmbed";
import EmbedYoutube from '@/components/YoutubeEmbed';
export default {
  name: "Day2",
  components: {
    EmbedScratch,
    EmbedYoutube
  },
  data() {
    return {
      showKind: "none",
      showKindCode: "none"
    };
  }
};
</script>

<style>
/*
.yt-video h3 {
  font-size:16px!important;
}
.yt-video .play {
     
        width: 280px!important; 
        height: 157px!important;
    }
 */
ul.iam {
  padding: 0;
  margin: 24px 0;
}

ul.iam li {
  display: inline-block;
  margin: 10px;
}

ul.iam li a {
  display: block;
  background: #00ffd4;
  color: #000000;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-decoration: none;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}

ul.iam li a.active {
  background: #ff00f9;
  color: #fff;
}

.spiltype-eks-container {
  display: flex;
  justify-content: center;
}

.spiltype-eks {
  border: 1px solid black;
  line-height: 0;
  display: block;
  width: 200px;
  margin: 12px;
}

.spiltype-eks img {
  width: 100%;
}
.bullet{
  background:#ff00f9;
  color:#ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/undervisning/dag-2.vue